import React, { useState } from 'react';
import MultiSelectCheckboxGroup from '../../components/CheckBoxFilter';
import VerticalTable from '../../components/verticalTable';
import { useTranslation } from 'react-i18next';
import { sixMonthsAgoFormatted, twoDaysAgoFormatted } from '../../constants/intex';

const DLASummary = () => {
  const { t } = useTranslation();
  
  

  const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>({
    periodWithOutDay: ["month"],
    fromDate: [sixMonthsAgoFormatted],
    toDate: [twoDaysAgoFormatted],
  });

  const filters = [
    { key: "state", type: "select", label: t("filters.state") },
    // { key: "territory", type: "select", label: t("filters.territory") },
    { key: "cluster", type: "select", label: t("filters.cluster") },
    { key: "branch", type: "select", label: t("filters.branch") },
    { key: "periodWithOutDay", type: "singleSelect", label: t("filters.period") },
    { key: "fromDate", type: "date", label: t("filters.fromDate"), maxValue: selectedFilters.toDate },
    { key: "toDate", type: "date", label: t("filters.toDate"), maxValue: twoDaysAgoFormatted },
  ];

  const [applyFilter, setApplyFilter] = useState<boolean>(false);

  const handleFilterChange = (updatedValues: Record<string, string[]>) => {
    setSelectedFilters(updatedValues);
  };

  const handleCancelClick = () => {
    setSelectedFilters({
      periodWithOutDay: ["month"],
      fromDate: [sixMonthsAgoFormatted],
      toDate: [twoDaysAgoFormatted]
    });
    setApplyFilter(!applyFilter);
  };

  // --- Table 1: Application Volume ---
  const applicationHeaders = ["","Aug 25", "Sep 26", "Dec Q3", "Dec Q4"];
  const applicationData = [
    { category: "Total Applications", values: ["3%", "9%", "0.81%", "0.82%"] },
    { category: "Approved Applications", values: ["1%", "3%", "0.32%", "0.30%"] },
    { category: "Declined Applications", values: ["2%", "6%", "0.49%", "0.52%"] },
    { category: "Approval Rate", values: ["33%", "33%", "39%", "36%"] },
  ];

  // --- Table 2: Decline Reason ---
  const declineHeaders = ["","Sep Q", "Oct Q", "Nov Q"];
  const declineData = [
    { category: "Age not allowed", values: ["30%", "30%", "27%"] },
    { category: "Branch Manager Declined", values: ["30%", "20%", "27%"] },
    { category: "Credit Issue", values: ["10%", "10%", "10%"] },
    { category: "Customer not eligible", values: ["10%", "10%", "10%"] },
    { category: "Duplicate application found", values: ["10%", "10%", "10%"] },
    { category: "Old loan Declined", values: ["10%", "20%", "16%"] },
  ];

  return (
    <div className="page-content">
      <div className="header">
      {t('TTD_DLA.pageTitle')}
      </div>

      {/* Filters */}
      <div className="content px-3">
        <MultiSelectCheckboxGroup
          filters={filters}
          selectedValues={selectedFilters}
          onChange={handleFilterChange}
          isLoading={[false]}
          buttons={[
            { label: t("buttons.apply"), onClick: () => setApplyFilter(!applyFilter) },
            { label: t("buttons.cancel"), onClick: handleCancelClick },
            { label: t("buttons.download"), onClick: () => alert("Download triggered") },
          ]}
        />
      </div>

      {/* Application Volume Table */}
      <div className="p-2 me-3">
        <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', textAlign: "start", paddingLeft: "15px", color: '#14213d' }}>
        {t('TTD_DLA.Volume')}
        </h2>
        <VerticalTable headers={applicationHeaders} data={applicationData} loading={false} />
      </div>

      {/* Decline Reason Table */}
      <div className="p-2 me-3 mt-5">
        <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', textAlign: "start", paddingLeft: "15px", color: '#14213d' }}>
        {t('TTD_DLA.Reasons')}
        </h2>
        <VerticalTable headers={declineHeaders} data={declineData} loading={false} />
      </div>
    </div>
  );
};

export default DLASummary;
